import { ButtonType, CustomButton, Table } from 'soprasteria-ui-library';
import * as React from 'react';
import { OrthodonticReferralTreatmentApi } from '../../../../api/OrthodonticReferralTreatmentApi';
import { useAuth } from '../../../../App';
import { IOrthodonticReferralICD10Code } from '../../../../models/IOrthodonticReferral';

interface IOrthodonticReferralICD10CodesTable {
    orthodonticReferralICD10Codes?: IOrthodonticReferralICD10Code[];
    canDeleteOrthodonticReferralICD10CodeMapping: boolean;
    changeSuccessMessage: (message: string) => void;
    getOrthodonticReferral: (id: number, refresh: boolean) => void;
    orthodonticReferralId: number;
}

interface IDeleteStatus {
    isDeleting: boolean;
    key?: number;
}

export const OrthodonticReferralICD10CodesTable: React.FunctionComponent<IOrthodonticReferralICD10CodesTable> = ({ orthodonticReferralICD10Codes, canDeleteOrthodonticReferralICD10CodeMapping, changeSuccessMessage, getOrthodonticReferral, orthodonticReferralId }) => {
    const auth = useAuth();
    const api = new OrthodonticReferralTreatmentApi(auth);
    const [deleteStatus, setDeleteStatus] = React.useState<IDeleteStatus>();

    const deleteICD10CodeMapping = (orthodonticReferralICD10CodeMappingId: number, key: number) => {
        setDeleteStatus({ isDeleting: true, key: key });
        api.deleteICD10CodeMapping(orthodonticReferralICD10CodeMappingId, () => {
            changeSuccessMessage("ICD10-koden har tagits bort");
            getOrthodonticReferral(orthodonticReferralId, true);
        }, undefined, () => setDeleteStatus({ isDeleting: false }));
    }

    return (
        <Table>
            <thead>
                <tr>
                    <th>ICD10-kod</th>
                    <th>Beskrivning</th>
                    {
                        orthodonticReferralICD10Codes && orthodonticReferralICD10Codes.length > 0 && canDeleteOrthodonticReferralICD10CodeMapping ?
                            <th style={{ width: "6%" }}></th>
                            : null
                    }
                </tr>
            </thead>
            <tbody>
                {
                    orthodonticReferralICD10Codes && orthodonticReferralICD10Codes.length > 0 ?
                        orthodonticReferralICD10Codes.map((ICD10code, key) =>
                            <tr key={key}>
                                <td>{ICD10code.code}</td>
                                <td>{ICD10code.description}</td>
                                {
                                    orthodonticReferralICD10Codes.length > 0 && canDeleteOrthodonticReferralICD10CodeMapping ?
                                        <td style={{ width: "6%" }}>
                                            <CustomButton
                                                onClick={() => deleteICD10CodeMapping(ICD10code.orthodonticReferralICD10CodeMappingId, key)}
                                                isLoading={deleteStatus?.isDeleting && deleteStatus?.key === key}
                                                buttonType={ButtonType.delete}
                                                buttonText="" />
                                        </td>
                                        : null
                                }
                            </tr>
                        )
                        : <tr><td colSpan={orthodonticReferralICD10Codes && orthodonticReferralICD10Codes.length > 0 && canDeleteOrthodonticReferralICD10CodeMapping ? 3 : 2}>Det finns inga registrerade ICD10-koder</td></tr>
                }
            </tbody>
        </Table>
    )
}